export default "__VITE_ASSET__krZ3Wd$F__"